import React from "react";
import { Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import { AccordionComponent } from "../../../../CommonElements/Accordion";
import { renderPermissionsForDisplay } from "../utils/permissionDisplayRenderer";

const PermissionDisplaySkeleton = ({ col = 6 }) => {
  return (
    <div className="permission-display-skeleton">
      <div className="skeleton-accordion">
        {/* Render multiple skeleton accordion items */}
        {[1, 2].map((index) => (
          <div key={index} className={`skeleton-accordion-item col-md-${col}`}>
            <div className="skeleton skeleton-accordion-header"></div>
            <div className="skeleton-permission-list">
              {/* Render skeleton permission items */}
              {[1, 2, 4].map((permIndex) => (
                <div key={permIndex} className="skeleton-permission-item">
                  <div className="skeleton skeleton-checkbox"></div>
                  <div className="skeleton skeleton-permission-text"></div>
                </div>
              ))}
            </div>
            {/* Add nested section for some items */}
            {index <= 2 && (
              <div className="skeleton-nested-section">
                <div className="skeleton skeleton-nested-header"></div>
                {[1, 2].map((nestedIndex) => (
                  <div key={nestedIndex} className="skeleton-permission-item">
                    <div className="skeleton skeleton-checkbox"></div>
                    <div className="skeleton skeleton-permission-text"></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const PermissionDisplay = ({
  permissionsData,
  selectedPermissions = new Set(),
  loading = false,
  col,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return <PermissionDisplaySkeleton col={col} />;
  }

  if (!permissionsData?.length) {
    return null;
  }

  const accordionItems = renderPermissionsForDisplay({
    nodes: permissionsData,
    selectedPermissions,
    col,
    t, // Pass the t function
  });

  return (
    <>
      <AccordionComponent className="vstack gap-2" items={accordionItems} />
    </>
  );
};

export default PermissionDisplay;
